import { useEffect, useRef } from "react";

// Hook
export default value => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
